import { createRouter, createWebHistory } from "vue-router/auto";
import { routes } from "vue-router/auto-routes";
import { resolveNavigation } from "@/router/guard";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...routes,
    {
      path: "/user-settings/general",
      redirect: "/general-settings/general",
    },
    {
      path: "/user-settings/license",
      redirect: "/general-settings/license",
    },
  ],
});

let routeController = new AbortController();

export function getRouteSignal(): AbortSignal {
  return routeController.signal;
}

router.beforeEach(async (to) => {
  // Side effect: cancel in-flight requests from the route we are leaving.
  routeController.abort();
  routeController = new AbortController();

  // Pure decision (auth / silent-refresh / RBAC) lives in guard.ts so it is
  // unit-testable without a real router.
  return resolveNavigation(to);
});

export default router;
